module.exports = __webpack_public_path__ + "img/edit.c5814c02.png";